<template>
  <div class="text-left">
    <div>Password should contain:</div>
    <ul class="passwordList">
      <li><div v-bind:class="{ 'grayout': !props.isLengthPolicyMeet }">At least ten characters.</div></li>
      <li v-if="requireUppercase"><div v-bind:class="{ 'grayout': !props.isUppercasePolicyMeet }">At least one uppercase letter.</div></li>
      <li v-if="requireLowercase"><div v-bind:class="{ 'grayout': !props.isLowercasePolicyMeet }">At least one lowercase letter.</div></li>
      <li v-if="requireSymbols"><div v-bind:class="{ 'grayout': !props.isSymbolsPolicyMeet }">At least one special character ( ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > &lt; ' : ; | _ ~ ` = + - ).</div></li>
      <li v-if="requireNumbers"><div v-bind:class="{ 'grayout': !props.isRequireNumberPolicyMeet }">At least one number.</div></li>
    </ul>
  </div>
</template>

<script setup lang="ts">

import { defineProps } from 'vue'
import { useConfigSync } from '@/config/useConfig'
const config = useConfigSync()
const requireLowercase = config.password_policy.require_lowercase
const requireNumbers = config.password_policy.require_numbers
const requireSymbols = config.password_policy.require_symbols
const requireUppercase = config.password_policy.require_uppercase
const minimumLength = config.password_policy.minimum_length
const props = defineProps(['isSymbolsPolicyMeet', 'isLengthPolicyMeet', 'isLowercasePolicyMeet', 'isRequireNumberPolicyMeet', 'isUppercasePolicyMeet'])
</script>

<style>
.grayout {
  opacity: 0.9;
  color: #7188A7;
}

.lp .passwordList {
  padding-left: 16px;
}

.passwordList li {
  font-size: 13px;
  list-style: disc;
}
</style>
